import { http } from "../index";
import Config from "../config/config";
import { PostData, query_params } from "../helpers/params";

const OTP = ({ index, mobile, sms }) => {
  const data = { index, mobile };
  if (sms) data.sms_code = sms;
  return http.post({
    url: Config.User.OTP,
    data: PostData(data),
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const Verification = {
  Upload: ({ type, side, file }) => {
    return http.post({
      url: Config.User.Verification.replace("{service}", "uploadImage"),
      data: PostData({ type, side, file }),
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  CheckStatus: () => {
    return http.get({
      url: Config.User.Verification.replace("{service}", "checkFinish"),
    });
  },
  Finish: () => {
    return http.get({
      url: Config.User.Verification.replace("{service}", "finishUploads"),
    });
  },
};
const ReVerify = ({ smsCode }) => {
  return http.post({
    url: Config.User.ReVerify.concat(smsCode ? `&sms_code=${smsCode}` : ""),
  });
};
const ReferralVerification = {
  Upload: ({ referralId, type, side, file }) => {
    const params = {
      service: "uploadImage",
      id: referralId,
    };
    return http.post({
      url: Config.Guest.Register.replace("{mode}", "referral_reg_api").concat(
        `&${query_params(params)}`,
      ),
      data: PostData({ type, side, file }),
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  Finish: ({ referralId }) => {
    const params = {
      service: "finishUploads",
      id: referralId,
    };
    return http.get({
      url: Config.Guest.Register.replace("{mode}", "referral_reg_api").concat(
        `&${query_params(params)}`,
      ),
    });
  },
};
const Info = () => {
  return http.get({ url: Config.User.Info });
};
const Balance = () => {
  return http.get({ url: Config.User.Balance });
};
const MainBalance = () => {
  return http.get({ url: Config.User.MainBalance });
};
const Level = () => {
  return http.get({ url: Config.User.Level });
};
const Notifications = {
  list: () => {
    return http.get({
      url: Config.Notifications.List.replace("{lang}", "ka"),
    });
  },
  unread: () => {
    return http.get({ url: Config.Notifications.Unread });
  },
  get: ({ id, platform = "web" }) => {
    return http.get({
      url: Config.Notifications.Get.replace("{id}", id).replace(
        "{platform}",
        platform,
      ),
    });
  },
  read: ({ id, platform = "web" }) => {
    return http.get({
      url: Config.Notifications.Read.replace("{id}", id),
    });
  },
  readAll: ({ id, platform = "web" }) => {
    return http.get({
      url: Config.Notifications.ReadAll.replace("{messages}", id.join(",")),
    });
  },
  deleteAll: ({ id, platform = "web" }) => {
    return http.get({
      url: Config.Notifications.deleteAll.replace("{messages}", id.join(",")),
    });
  },
};
const Toasts = ({ timestamp }) => {
  return http.get({
    url: Config.User.Notifications.Ping.replace("{timestamp}", timestamp),
  });
};
const TicketHistory = ({ from, to, status }) => {
  return http.post({
    url: Config.User.TicketHistory,
    data: PostData({ from, to, status }),
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const TransactionHistory = ({ from, to }) => {
  return http.post({
    url: Config.User.TransactionHistory,
    data: PostData({ from, to }),
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const AuthHistory = () => {
  return http.get({ url: Config.User.AuthHistory });
};
const PokerStats = () => {
  return http.get({ url: Config.User.PokerStats });
};
const PromoCode = ({ code, smsCode }) => {
  const data = { code: code };
  if (smsCode) {
    data.sms_code = smsCode;
  }
  return http.post({
    url: Config.User.Promo,
    data: PostData(data),
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const Cashback = () => {
  return http.get({ url: Config.User.Cashback });
};
const Safe = {
  open: ({ smsCode, loader }) => {
    if (smsCode) {
      return http.post({
        url: Config.User.Safe.replace("{act}", "open"),
        data: PostData({ sms_code: smsCode }),
        headers: { "Content-Type": "multipart/form-data" },
        loader,
      });
    }
    return http.post({
      url: Config.User.Safe.replace("{act}", "open"),
      loader,
    });
  },
  transfer: ({ from, to, money }) => {
    return http.post({
      url: Config.User.Accounts,
      data: PostData({ from, to, money }),
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  close: () => {
    return http.post({
      url: Config.User.Safe.replace("{act}", "close"),
    });
  },
  balance: () => {
    return http.post({
      url: Config.User.Safe.replace("{act}", "getBalance"),
    });
  },
  balanceToSms: () => {
    return http.post({
      url: Config.User.Safe.replace("{act}", "sendBalanceToPhone"),
    });
  },
};
const ResetPassword = ({ passwordOld, passwordNew, passwordConfirm }) => {
  return http.post({
    url: Config.User.ResetPassword,
    data: PostData({
      password_old: passwordOld,
      password_new1: passwordNew,
      password_new2: passwordConfirm,
    }),
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const SetSms = ({ value, smsCode, loader }) => {
  const data = { val: value };
  if (smsCode) {
    data.sms_code = smsCode;
  }
  return http.post({
    url: Config.User.SetSms,
    data: PostData(data),
    headers: { "Content-Type": "multipart/form-data" },
    loader,
  });
};
const SetSmsNotify = ({ value, smsCode }) => {
  const data = { val: value };
  if (smsCode) {
    data.sms_code = smsCode;
  }
  return http.post({
    url: Config.User.SetSmsNotify,
    data: PostData(data),
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const UpdateInfo = ({ key, value }) => {
  const data = new FormData();
  data.append("fieldName", key);
  data.append("fieldValue", value);

  return http.post({
    url: Config.User.UpdateInfo,
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const GetMobile = () => {
  return http.get({ url: Config.User.GetMobile });
};
const UpdateMobile = ({ smsCode, mobile }) => {
  if (!smsCode && !mobile) {
    return http.post({
      url: Config.User.UpdateMobile.replace("{mode}", "edit"),
    });
  } else {
    const data = {};
    if (smsCode) {
      data.sms_code = smsCode;
    } else {
      data.mobile = mobile;
    }
    return http.post({
      url: Config.User.UpdateMobile.replace("{mode}", ""),
      data: PostData(data),
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
};
const GoMobile = ({ action }) => {
  return http.get({ url: Config.User.GoMobile.replace("{action}", action) });
};
const Referrals = () => {
  return http.get({ url: Config.User.Referrals });
};
const Logout = () => {
  return http.get({ url: Config.User.Logout });
};
const CheckLeaderCardStatus = () => {
  return http.get({ url: Config.User.CheckLeaderCardStatus });
};
const CheckLeaderCardKey = () => {
  return http.get({ url: Config.User.CheckLeaderCardKey });
};
const Promotions = () => {
  return http.get({ url: Config.User.Promotions });
};

const Kvalifika = () => {
  return http.get({ url: Config.User.Kvalifika });
};

const DisableAccount = ({period,code}) => {
  let otpCode=""
   if(code){
      otpCode="&sms_code="+code
   }
  return http.get({ url: Config.User.DisableAccount.replace("{period}",period).concat(otpCode)});
};

export default {
  Kvalifika,
  DisableAccount,
  OTP,
  Verification,
  ReferralVerification,
  ReVerify,
  Info,
  Balance,
  MainBalance,
  Level,
  ResetPassword,
  Notifications,
  TicketHistory,
  TransactionHistory,
  AuthHistory,
  PokerStats,
  Cashback,
  Safe,
  PromoCode,
  SetSms,
  SetSmsNotify,
  UpdateInfo,
  GetMobile,
  UpdateMobile,
  GoMobile,
  Referrals,
  Logout,
  CheckLeaderCardStatus,
  CheckLeaderCardKey,
  Promotions,
  Toasts,
};
